import { BASE_URL } from 'constants/values';
export function downloadLink(id: number, link: string) {
  return BASE_URL + link + id;
}
